import type { ReactNode } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { PATH_DASHBOARD } from '../routes/paths';

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated, isInitialized } = useAuth();
  const [searchParams] = useSearchParams();
  const redirectParam = searchParams.get('redirect');
  const to = redirectParam?.startsWith('/') ? redirectParam : PATH_DASHBOARD.root;

  if (!isInitialized) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to={to} replace />;
  }

  return <>{children}</>;
}
